import * as React from "react";
import type { SVGProps } from "react";
const SvgStorageLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      fill="#23F6E7"
      d="M14 6.333v2c0 1.657-2.687 3-6 3s-6-1.343-6-3v-2c0 1.657 2.687 3 6 3s6-1.343 6-3M2 9.667c0 1.656 2.687 3 6 3s6-1.344 6-3v2c0 1.656-2.687 3-6 3s-6-1.344-6-3zM8 8C4.687 8 2 6.657 2 5s2.687-3 6-3 6 1.343 6 3-2.687 3-6 3"
    />
    <path
      fill="#90B9FF"
      d="M14 5.333v2c0 1.657-2.687 3-6 3s-6-1.343-6-3v-2c0 1.657 2.687 3 6 3s6-1.343 6-3M2 8.667c0 1.656 2.687 3 6 3s6-1.344 6-3v2c0 1.656-2.687 3-6 3s-6-1.344-6-3zM8 7C4.687 7 2 5.657 2 4s2.687-3 6-3 6 1.343 6 3-2.687 3-6 3"
      opacity={0.2}
    />
  </svg>
);
export default SvgStorageLight;
